<h2>Palets</h2>
<!--Table-->
<div class="card">

  <form [formGroup]="searchForm" (ngSubmit)="search()" class="mb-4 gap-2 p-4 surface-card shadow-2 border-round ">
    <div class="formgroup-inline">

      <div class="field col-12 xl:col-2">
        <label for="warehouse" class="block font-bold mb-2">Bodega</label>
        <p-select id="warehouse" optionLabel="name" optionValue="name" formControlName="warehouse"
          [options]="warehouses" placeholder="Selecciona una bodega" optionLabel="name"
        [fluid]="true"></p-select>
      </div>

      <div class="field col-12 xl:col-3">
        <label for="category" class="block font-bold mb-2">Cuenta</label>
        <p-select [options]="accounts" formControlName="accountId" placeholder="Selecciona una cuenta"
          optionLabel="name" [resetFilterOnHide]="true" [filter]="true" lazy="true"
          (onFilter)="loadAccounts($event)" [showClear]="true" placeholder="Selecciona una Cuenta"
          optionValue="accountId" [disabled]="!hasAccountAccess" [loading]="accountLoading" [fluid]="true" autofocus
          [appendTo]="'body'">
        </p-select>
      </div>

      <div class="field col-12 xl:col-2">
        <label for="palletCode" class="block font-bold mb-2">Código de Palet</label>
        <p-iconField class="w-full">
          <p-inputIcon class="pi pi-code" />
          <input pInputText id="palletCode" formControlName="palletCode"
            placeholder="Buscar por Código de Pallet" class="w-full">
        </p-iconField>
      </div>

      <div class="field col-12 xl:col-2">
        <label for="status" class="block font-bold mb-2">Estado</label>
        <p-multiSelect formControlName="status" [options]="statuses" [filter]="false"
          placeholder="Selecciona Estado(s)" display="chip" showClear [fluid]="true">
          <ng-template let-option pTemplate="item">
            <p-tag [value]="option.value" [severity]="getSeverity(option.label)" />
          </ng-template>
        </p-multiSelect>
      </div>

      <p-accordion class="w-full" expandIcon="pi pi-plus" collapseIcon="pi pi-minus" value="-1">
        <p-accordion-panel value="0">
          <p-accordion-header>
            <span class="flex align-items-center gap-2 w-full">
              <span class="font-bold white-space-nowrap">
                Búsqueda Avanzada
              </span>
            </span>
          </p-accordion-header>
          <p-accordion-content>
            <div class="formgroup-inline">
              <div class="field col-12 xl:col-2">
                <label for="flooring" class="block font-bold mb-2">Nivel</label>
                <p-select formControlName="flooring" [options]="floorings"
                placeholder="Selecciona un Nivel" showClear [fluid]="true"></p-select>
              </div>
              <div class="field col-12 xl:col-2">
                <label for="location" class="block font-bold mb-2">Locación</label>
                <p-iconField class="w-full">
                  <p-inputIcon class="pi pi-map-marker" />
                  <input pInputText id="location" formControlName="location"
                    placeholder="Buscar por Locación" class="w-full">
                </p-iconField>
              </div>
              <div class="field col-12 xl:col-2">
                <label for="creationDateFrom" class="block font-bold mb-2">Fecha de Creación Desde</label>
                <p-datepicker id="creationDateFrom" formControlName="creationDateFrom" dateFormat="dd/mm/yy"
                [appendTo]="'body'" showIcon></p-datepicker>
              </div>

              <div class="field col-12 xl:col-2">
                <label for="creationDateTo" class="block font-bold mb-2">Fecha de Creación Hasta</label>
                <p-datepicker id="creationDateTo" formControlName="creationDateTo" dateFormat="dd/mm/yy"
                [appendTo]="'body'" showIcon></p-datepicker>
              </div>
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>

    </div>

    <div class="flex justify-content-end gap-2 mt-4">
      <button pButton type="submit" label="Buscar" icon="pi pi-search" severity="primary"></button>
      <button pButton type="button" label="Limpiar" icon="pi pi-times" severity="secondary"
      (click)="resetForm()"></button>
    </div>
  </form>

  <div class="flex justify-content-end mb-2">
    <p-button icon="pi pi-map" (click)="overlayPalets.toggle($event)" pTooltip="Configurar columnas"></p-button>
  </div>

  <p-popover #overlayPalets [style]="{width:'300px'}">

    <div class="dropdown-header">
      <div class="dropdown-header-left">
        <p-checkbox [(ngModel)]="selectAllPalets" binary="true" (onChange)="toggleAllPalets()"></p-checkbox>

        <input type="text" pInputText placeholder="Buscar columna" [(ngModel)]="searchTerm"
          class="column-search-input" />
      </div>

      <button pButton icon="pi pi-times" (click)="overlayPalets.hide()"
      class="p-button-rounded p-button-text"></button>
    </div>
    <br>

      <div class="columns-list mb-2" style="max-height:200px; overflow:auto;">
        @for (col of filteredColumns; track col) {
          <div>
            <div class="field-checkbox">
              <p-checkbox [(ngModel)]="col.visible" binary="true" [inputId]="'col-' + col.field" />
              <label [for]="'col-' + col.field">{{ col.header }}</label>
            </div>
              </div>
            }
          </div>

          <div class="footer flex justify-content-end gap-2">
            <button pButton label="Limpiar" severity="secondary" (click)="clearSelectionPalets()"></button>
            <button pButton label="Guardar" (click)="saveSelectionPalets()"></button>
          </div>
        </p-popover>

        <p-table [value]="pallets" dataKey="palletId" [paginator]="true" [rows]="tableRows" [totalRecords]="totalRecords"
          [lazy]="true" (onLazyLoad)="loadItems($event)" [loading]="loading" [responsiveLayout]="'scroll'"
          [rowsPerPageOptions]="[30, 50, 100, 200]" [showCurrentPageReport]="true"
          currentPageReportTemplate="Mostrando {first} al {last} de {totalRecords} Registros"
          styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped" [sortField]="'palletId'" [sortOrder]="-1">

          <ng-template pTemplate="header">
            <tr>
              @for (col of appliedColumnsPalets; track col) {
                <th>{{ col.header }}</th>
              }
              @if (hasDeleteAccess) {
                <th>Acciones</th>
              }
            </tr>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              @for (col of appliedColumnsPalets; track col) {
                <th [pSortableColumn]="col.sortable ? col.field : ''">
                  {{ col.header }}
                  @if (col.sortable) {
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                  }
                </th>
              }
              @if (hasDeleteAccess) {
                <th>Acciones</th>
              }
            </tr>
          </ng-template>


          <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
            <tr>
              @for (col of appliedColumnsPalets; track col) {
                <td>
                  @if (col.field === 'palletId') {
                    <span>
                      {{ rowIndex + 1 }}
                    </span>
                  }
                  <!-- STATUS -->
                  @if (col.field === 'status') {
                    <p-tag [value]="item.status"
                      [severity]="getSeverity(item.status)">
                    </p-tag>
                  }
                  <!-- DATES -->
                  @if (col.isDate) {
                    <span>
                      {{
                      (col.onlyIfCompleted && item.status !== 'COMPLETADA')
                      ? ''
                      : (resolveField(item, col.field) | date:'dd/MMM/yyyy h:mm a' | lowercase)
                      }}
                    </span>
                  }
                  <!-- TEXT/NUMBER -->
                  @if (!col.isDate && col.field !== 'status' && col.field !== 'palletId') {
                    <span>
                      {{ resolveField(item, col.field) }}
                    </span>
                  }
                </td>
              }

              @if (hasDeleteAccess) {
                <td style="text-align: center;">
                  @if (item.status === 'CREADA') {
                    <button pButton icon="pi pi-trash" severity="danger"
                      class="p-button-rounded p-button-xs" pTooltip="Eliminar" (click)="deletePallet(item)"
                      style="width: 30px; height: 30px; padding: 0;">
                    </button>
                  }
                </td>
              }
            </tr>
          </ng-template>

          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between">
              En total hay {{ pallets ? pallets.length : 0 }} palets en la página actual
            </div>
          </ng-template>
        </p-table>

      </div>

      <p-toast></p-toast>
      <p-confirmDialog></p-confirmDialog>